module.exports = __webpack_public_path__ + "img/Edit_Icon_Grey.ca003d36.svg";